var EN = EN || {};

EN.ScrollSpy = (function ($) {

    var options = {
        selectors: {
            /**
             * Spy, gets class once the target gets in the viewport.
             * Must have equal value as the spy target
             */
            spy: '[data-en-scrollspy-spies]',
            /**
             * Spied target.
             */
            spyTargets: '[data-en-scrollspy-spied-by]',
        },
        rawSelectors: {
            activeSpy: 'en-active-spy',
            activeSpyTarget: 'en-active-spy-target',
            spyTargets: 'data-en-scrollspy-spied-by',
            spy: 'data-en-scrollspy-spies',
        },
    }

    var spyTargets = document.querySelectorAll(options.selectors.spyTargets);

    var observerCallback = function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {

                var $spyTarget = $(entry.target);
                var spyId = $spyTarget.attr(options.rawSelectors.spyTargets);
                var $spy = $('[' + options.rawSelectors.spy + '=' + spyId + ']');

                $(options.selectors.spyTargets).removeClass(options.rawSelectors.activeSpyTarget);
                $(options.selectors.spy).removeClass(options.rawSelectors.activeSpy);

                $spyTarget.addClass(options.rawSelectors.activeSpyTarget);
                $spy.addClass(options.rawSelectors.activeSpy);
            }
        });
    }

    var init = function () {

        var historyScrollspy = new IntersectionObserver(observerCallback, {
            threshold: 0.3,
            rootMargin: '0px 0px -50% 0px',
        });

        // start observing
        if (spyTargets) {
            spyTargets.forEach(function (era) {
                historyScrollspy.observe(era);
            });
        }

    }

    return {
        init: init
    }

})(jQuery);